(function () {
  'use strict';

  if (window.KuKirinLocaleLinksLoaded) return;
  window.KuKirinLocaleLinksLoaded = true;

  function getRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(0) !== '/') root = '/' + root;
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  function shouldSkip(href) {
    if (!href) return true;
    return /^(#|mailto:|tel:|sms:|javascript:|data:)/i.test(href);
  }

  function localizePath(href) {
    if (shouldSkip(href) || href.charAt(0) !== '/' || href.indexOf('//') === 0) return href;

    var root = getRoot();
    if (root === '/') return href;

    var prefix = root.slice(0, -1);
    if (href === prefix || href.indexOf(prefix + '/') === 0) return href;

    /* Respect links that explicitly target another locale. */
    if (/^\/[a-z]{2}(?:-[a-z]{2})?(?:\/|$)/i.test(href)) return href;

    return prefix + href;
  }

  function processLink(link) {
    if (!link || !link.getAttribute) return;
    var href = link.getAttribute('href');
    var localized = localizePath(href);
    if (localized !== href) link.setAttribute('href', localized);
  }

  function process(scope) {
    scope = scope || document;
    if (scope.matches && scope.matches('a[href],area[href]')) processLink(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('a[href],area[href]').forEach(processLink);
  }

  function initObserver() {
    if (!('MutationObserver' in window) || !document.documentElement) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node && node.nodeType === 1) process(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    process(document);
    initObserver();
  }, { once: true });
  document.addEventListener('shopify:section:load', function (event) { process(event.target); });
  window.addEventListener('pageshow', function () { process(document); });

  process(document);
})();
